import { IConfigTable } from '../../models/config.model';
import { IAttachment, IAttachmentContainer } from '../../models/dms/attachment.model';
import { IBranchSyncStatus } from '../../models/dms/branch.model';
import { IAttendanceClocking, IClockingHistory, ILabourClocking, ITechClockingDetail } from '../../models/dms/clocking.model';
import { IFranchiseSyncStatus } from '../../models/dms/franchise.model';
import { IRepairOrder, IRepairOrderSyncStatus } from '../../models/dms/repairOrder.model';
import { IClockingRequestQueueItem, ITechCommentRequestQueueItem, IVehicleAttachmentRequestQueueItem } from '../../models/dms/requestQueue.model';
import { IStockUnitDetails } from '../../models/dms/stockUnit.model';
import { IMediaSettingsSyncStatus, ISystemConfigurationsSyncStatus } from '../../models/dms/systemConfiguration.model';
import { ITechnician, IWorkCategorySyncStatus } from '../../models/dms/technician.model';
import { ITechComment } from '../../models/dms/technicianComments.model';
import { IDelayCodeSyncStatus } from '../../models/dms/typecode.model';
import { IWorkshopVehicleDetails } from '../../models/dms/workshopVehicle.model';
import { IJwt } from '../../models/portal/auth.model';
import { ICompany } from '../../models/portal/company.model';
import { IDatabase } from '../../models/portal/database.model';
import { ISQLQueryResponse } from '../../models/sql.model';
import { AppDispatch } from '../../store';
import { setIsAuthenticatedState, setSelectedDealerCodeState, setTechnicianState, setTokenState } from '../../store/authSlice';
import { setBranchesSyncState } from '../../store/branchSyncSlice';
import { setSelectedClockingHistoryState } from '../../store/clockingHistorySlice';
import { setSelectedCompanyState } from '../../store/companySlice';
import { setSelectedDatabaseState } from '../../store/databaseSlice';
import { setDelayCodesSyncState } from '../../store/delayCodeSyncSlice';
import { setFiltersOrSortsState, setOrderByDateDescendingState, setSelectedBranchCodeState, setTechCodeCheckboxState, setTodaysBookingsCheckboxState } from '../../store/filterMenuSlice';
import { setSelectedFixedAssetState } from '../../store/fixedAssetSlice';
import { setFranchisesSyncState } from '../../store/franchiseSyncSlice';
import { setAllowPermissionState, setHasAskedPermissionState } from '../../store/locationSlice';
import { setMediaSettingsSyncState } from '../../store/mediaSettingsSyncSlice';
import { setSelectedRepairOrderState } from '../../store/repairOrderSlice';
import { setRepairOrderSyncState } from '../../store/repairOrderSyncSlice';
import { setClockingRequestQueueState, setTechCommentRequestQueueState, setVehicleAttachmentRequestQueueState } from '../../store/requestQueueSlice';
import {
  setDistanceTrackingUserActivatedState,
  setDistanceTrackingUserPausedState,
  setEnableGeolocationLogState,
  setEnableOfflineModeState,
  setGpsServicesUserEnabledState,
  setIsDarkModeState,
  setScheduledEndTimeState,
} from '../../store/settingsSlice';
import { setSelectedStockUnitState } from '../../store/stockUnitSlice';
import { setSystemConfigurationsSyncState } from '../../store/systemConfigurationsSyncSlice';
import { setAttendanceClockingState, setLabourClockingState, setServerClockingDetailState } from '../../store/technicianClockingSlice';
import { setAdhocCommentsCacheState, setSelectedTechnicianCommentsState } from '../../store/technicianCommentSlice';
import { setSelectedUsernameState } from '../../store/userSlice';
import { setAdhocAttachmentsCacheState, setSelectedVehicleAttachmentsState } from '../../store/vehicleAttachmentSlice';
import { setWorkCategoriesSyncState } from '../../store/workCategorySyncSlice';
import { setSelectedWorkshopVehicleState } from '../../store/workshopVehicleSlice';
import { isUsingSQLiteRef, sqlConnectionProvider } from '../sqlConnectionProvider';

// PUBLIC

export enum ConfigName {
  Version = 'Version',
  IsAuthenticated = 'IsAuthenticated',
  SelectedDealerCode = 'SelectedDealerCode',
  SelectedUsername = 'SelectedUsername',
  SelectedCompany = 'SelectedCompany',
  SelectedDatabase = 'SelectedDatabase',
  AuthToken = 'AuthToken',
  SettingsIsDarkMode = 'SettingsIsDarkMode',
  LocationHasAskedPermission = 'LocationHasAskedPermission',
  LocationAllowPermission = 'LocationAllowPermission',
  SettingsEnableOfflineMode = 'SettingsEnableOfflineMode',
  SettingsGpsServicesUserEnabled = 'SettingsGpsServicesUserEnabled',
  SettingsDistanceTrackingUserActivated = 'SettingsDistanceTrackingUserActivated',
  SettingsDistanceTrackingUserPaused = 'SettingsDistanceTrackingUserPaused',
  SettingsScheduledEndTime = 'ScheduledEndTime',
  SettingsGeolocationLog = 'SettingsGeolocationLog',
  FilterMenuSelectedBranchCode = 'FilterMenuSelectedBranchCode',
  FilterMenuTechCodeCheckbox = 'FilterMenuTechCodeCheckbox',
  FilterMenuTodaysBookingsCheckbox = 'FilterMenuTodaysBookingsCheckbox',
  FilterMenuOrderByDateDescending = 'FilterMenuOrderByDateDescending',
  FilterMenuFiltersOrSorts = 'FilterMenuFiltersOrSorts',
  ClockingRequestQueue = 'ClockingRequestQueue',
  TechCommentRequestQueue = 'TechCommentRequestQueue',
  VehicleAttachmentRequestQueue = 'VehicleAttachmentRequestQueue',
  Technician = 'Technician',
  RepairOrderSync = 'RepairOrderSync',
  DelayCodesSync = 'DelayCodesSync',
  WorkCategoriesSync = 'WorkCategoriesSync',
  BranchesSync = 'BranchesSync',
  FranchisesSync = 'FranchisesSync',
  MediaSettingsSync = 'MediaSettingsSync',
  SystemConfigurationsSync = 'SystemConfigurationsSync',
  LabourClocking = 'LabourClocking',
  AttendanceClocking = 'AttendanceClocking',
  ServerClockingDetail = 'ServerClockingDetail',
  SelectedRepairOrder = 'SelectedRepairOrder',
  AccuracyList = 'AccuracyList',
  LocationsRaw = 'LocationsRaw',
  DistanceRaw = 'DistanceRaw',
  //LocationsAccurate = 'LocationsAccurate',
  DistanceAccurate = 'DistanceAccurate',
  SelectedWorkshopVehicle = 'SelectedWorkshopVehicle',
  SelectedStockUnit = 'SelectedStockUnit',
  SelectedTechComments = 'SelectedTechComments',
  AdhocTechCommentsCache = 'AdhocTechCommentsCache',
  SelectedVehicleAttachments = 'SelectedVehicleAttachments',
  AdhocAttachmentsCache = 'AdhocAttachmentsCache',
  AdhocVehicleAttachmentsCache = 'AdhocVehicleAttachmentsCache',
  SelectedClockingHistory = 'SelectedClockingHistory',
  SelectedFixedAsset = 'SelectedFixedAsset',
  //ScheduledStartTime = 'ScheduledStartTime',
  TransactionLog = 'TransactionLog',
  TransactionLogSize = 'TransactionLogSize',
  IsUsingSQLite = 'IsUsingSQLite',
}

const loadConfig = async (dispatch: AppDispatch) => {
  console.log('loading config data');

  await loadConfigString(ConfigName.SelectedDealerCode, dispatch, { type: setSelectedDealerCodeState.toString() });
  await loadConfigString(ConfigName.SelectedUsername, dispatch, { type: setSelectedUsernameState.toString() });
  await loadConfigBool(ConfigName.IsAuthenticated, dispatch, { type: setIsAuthenticatedState.toString() });
  await loadConfigObject<ICompany>(ConfigName.SelectedCompany, dispatch, { type: setSelectedCompanyState.toString() }, false);
  await loadConfigObject<IDatabase>(ConfigName.SelectedDatabase, dispatch, { type: setSelectedDatabaseState.toString() }, false);
  await loadConfigObject<IJwt>(ConfigName.AuthToken, dispatch, { type: setTokenState.toString() }, false);
  // Settings
  await loadConfigBool(ConfigName.SettingsIsDarkMode, dispatch, { type: setIsDarkModeState.toString() }, undefined, false);
  await loadConfigBool(ConfigName.SettingsEnableOfflineMode, dispatch, { type: setEnableOfflineModeState.toString() }, undefined, false);
  await loadConfigBool(ConfigName.SettingsGpsServicesUserEnabled, dispatch, { type: setGpsServicesUserEnabledState.toString() }, '1', false);
  await loadConfigBool(ConfigName.SettingsDistanceTrackingUserActivated, dispatch, { type: setDistanceTrackingUserActivatedState.toString() }, undefined, false);
  await loadConfigBool(ConfigName.SettingsDistanceTrackingUserPaused, dispatch, { type: setDistanceTrackingUserPausedState.toString() }, undefined, false);
  //await loadConfigString(ConfigName.ScheduledStartTime, dispatch, { type: setScheduledStartTimeState.toString() }, false);
  await loadConfigString(ConfigName.SettingsScheduledEndTime, dispatch, { type: setScheduledEndTimeState.toString() }, false);
  await loadConfigBool(ConfigName.SettingsGeolocationLog, dispatch, { type: setEnableGeolocationLogState.toString() }, undefined, false);
  // Location
  await loadConfigBool(ConfigName.LocationHasAskedPermission, dispatch, { type: setHasAskedPermissionState.toString() }, undefined, false);
  await loadConfigBool(ConfigName.LocationAllowPermission, dispatch, { type: setAllowPermissionState.toString() }, undefined, false);
  // Sync
  await loadConfigObject<IRepairOrderSyncStatus>(ConfigName.RepairOrderSync, dispatch, { type: setRepairOrderSyncState.toString() }, false);
  await loadConfigObject<IDelayCodeSyncStatus>(ConfigName.DelayCodesSync, dispatch, { type: setDelayCodesSyncState.toString() }, false);
  await loadConfigObject<IWorkCategorySyncStatus>(ConfigName.WorkCategoriesSync, dispatch, { type: setWorkCategoriesSyncState.toString() }, false);
  await loadConfigObject<IBranchSyncStatus>(ConfigName.BranchesSync, dispatch, { type: setBranchesSyncState.toString() }, false);
  await loadConfigObject<IFranchiseSyncStatus>(ConfigName.FranchisesSync, dispatch, { type: setFranchisesSyncState.toString() }, false);
  await loadConfigObject<IMediaSettingsSyncStatus>(ConfigName.MediaSettingsSync, dispatch, { type: setMediaSettingsSyncState.toString() }, false);
  await loadConfigObject<ISystemConfigurationsSyncStatus>(ConfigName.SystemConfigurationsSync, dispatch, { type: setSystemConfigurationsSyncState.toString() }, false);
  // Filter
  await loadConfigString(ConfigName.FilterMenuFiltersOrSorts, dispatch, { type: setFiltersOrSortsState.toString() }, false);
  await loadConfigString(ConfigName.FilterMenuSelectedBranchCode, dispatch, { type: setSelectedBranchCodeState.toString() }, false);
  await loadConfigBool(ConfigName.FilterMenuTechCodeCheckbox, dispatch, { type: setTechCodeCheckboxState.toString() }, undefined, false);
  await loadConfigBool(ConfigName.FilterMenuTodaysBookingsCheckbox, dispatch, { type: setTodaysBookingsCheckboxState.toString() }, undefined, false);
  await loadConfigBool(ConfigName.FilterMenuOrderByDateDescending, dispatch, { type: setOrderByDateDescendingState.toString() }, undefined, false);
  // Other
  await loadConfigObject<IClockingRequestQueueItem[]>(ConfigName.ClockingRequestQueue, dispatch, { type: setClockingRequestQueueState.toString() }, false);
  await loadConfigObject<ITechCommentRequestQueueItem[]>(ConfigName.TechCommentRequestQueue, dispatch, { type: setTechCommentRequestQueueState.toString() }, false);
  await loadConfigObject<IVehicleAttachmentRequestQueueItem[]>(ConfigName.VehicleAttachmentRequestQueue, dispatch, { type: setVehicleAttachmentRequestQueueState.toString() }, false);
  await loadConfigObject<ITechnician>(ConfigName.Technician, dispatch, { type: setTechnicianState.toString() }, false);
  await loadConfigObject<ILabourClocking>(ConfigName.LabourClocking, dispatch, { type: setLabourClockingState.toString() }, false);
  await loadConfigObject<IAttendanceClocking>(ConfigName.AttendanceClocking, dispatch, { type: setAttendanceClockingState.toString() }, false);
  await loadConfigObject<ITechClockingDetail>(ConfigName.ServerClockingDetail, dispatch, { type: setServerClockingDetailState.toString() }, false);
  await loadConfigObject<IRepairOrder>(ConfigName.SelectedRepairOrder, dispatch, { type: setSelectedRepairOrderState.toString() }, false);
  await loadConfigObject<IWorkshopVehicleDetails>(ConfigName.SelectedWorkshopVehicle, dispatch, { type: setSelectedWorkshopVehicleState.toString() }, false);
  await loadConfigObject<IStockUnitDetails>(ConfigName.SelectedStockUnit, dispatch, { type: setSelectedStockUnitState.toString() }, false);
  await loadConfigObject<ITechComment[]>(ConfigName.SelectedTechComments, dispatch, { type: setSelectedTechnicianCommentsState.toString() }, false);
  await loadConfigObject<ITechComment[]>(ConfigName.AdhocTechCommentsCache, dispatch, { type: setAdhocCommentsCacheState.toString() }, false);
  await loadConfigObject<IAttachmentContainer>(ConfigName.SelectedVehicleAttachments, dispatch, { type: setSelectedVehicleAttachmentsState.toString() }, false);
  await loadConfigObject<IAttachment[]>(ConfigName.AdhocAttachmentsCache, dispatch, { type: setAdhocAttachmentsCacheState.toString() }, false);
  await loadConfigObject<IClockingHistory[]>(ConfigName.SelectedClockingHistory, dispatch, { type: setSelectedClockingHistoryState.toString() }, false);
  await loadConfigObject<IStockUnitDetails>(ConfigName.SelectedFixedAsset, dispatch, { type: setSelectedFixedAssetState.toString() }, false);
};

const updateConfigString = async (configName: ConfigName | string, stringData: string, useStorage?: boolean) => {
  if (isUsingSQLiteRef && !useStorage) {
    let sqlcmd = `
      INSERT OR REPLACE INTO Config (Name, Value) VALUES ('${configName}', ?);`;
    let values: Array<any> = [stringData];
    await sqlConnectionProvider.run(sqlcmd, values);
  } else {
    await sqlConnectionProvider.storageSet(configName, stringData);
  }
};

const updateConfigBool = async (configName: ConfigName, boolData: boolean, useStorage?: boolean) => {
  const stringData = boolData ? '1' : '0';
  await updateConfigString(configName, stringData, useStorage);
};

const updateConfigInteger = async (configName: ConfigName, objectData: number, useStorage?: boolean) => {
  const numberData = parseInt(objectData.toFixed(0)).toString();
  await updateConfigString(configName, numberData, useStorage);
};

const updateConfigObject = async <T>(configName: ConfigName, objectData: T, useStorage?: boolean) => {
  const stringData = JSON.stringify(objectData);
  await updateConfigString(configName, stringData, useStorage);
};

const deleteConfig = async (configName: ConfigName | string, useStorage?: boolean) => {
  if (isUsingSQLiteRef && !useStorage) {
    let sqlcmd = `
      DELETE FROM Config WHERE Name = '${configName}';`;
    await sqlConnectionProvider.run(sqlcmd);
  } else {
    await sqlConnectionProvider.storageRemove(configName);
  }
};

const selectConfigString = async (configName: ConfigName | string, useStorage?: boolean) => {
  try {
    if (isUsingSQLiteRef && !useStorage) {
      const response = await sqlConnectionProvider.query(`
        SELECT Name, Value
        FROM   Config
        WHERE  Name = '${configName}'
      `);
      const data = response as ISQLQueryResponse<IConfigTable>;
      if (response?.values?.length) {
        const val = data.values[0].Value;
        return val;
      }
      return '';
    } else {
      const res = (await sqlConnectionProvider.storageGet(configName)) || '';
      return res;
    }
  } catch (ex) {
    console.error(`error loading config data for ${configName}`);
    throw ex;
  }
};

export { deleteConfig, loadConfig, selectConfigString, updateConfigBool, updateConfigInteger, updateConfigObject, updateConfigString };

// PRIVATE

const loadConfigString = async (configName: ConfigName | string, dispatch: AppDispatch, dispatcher: { payload?: string; type: string }, useStorage?: boolean) => {
  try {
    const val = await selectConfigString(configName, useStorage);
    dispatcher.payload = val;
    dispatch(dispatcher);
  } catch (ex) {
    console.error(`error loading ${configName} data`);
    throw ex;
  }
};

const loadConfigBool = async (configName: ConfigName, dispatch: AppDispatch, dispatcher: { payload?: boolean; type: string }, defaultIfUndefined: string = '0', useStorage?: boolean) => {
  try {
    let val = await selectConfigString(configName, useStorage);
    if (val !== '0' && val !== '1') {
      val = defaultIfUndefined;
    }
    const valBool = val === '1' ? true : false;
    dispatcher.payload = valBool;
    dispatch(dispatcher);
  } catch (ex) {
    console.error(`error loading ${configName} data`);
    throw ex;
  }
};

// const loadConfigInteger = async (configName: ConfigName, dispatch: AppDispatch, dispatcher: { payload?: number; type: string }, useStorage?: boolean) => {
//   try {
//     const val = await selectConfigString(configName, useStorage);
//     const valNumber = parseInt(val);
//     dispatcher.payload = valNumber;
//     dispatch(dispatcher);
//   } catch (ex) {
//     console.error(`error loading ${configName} data`);
//     throw ex;
//   }
// };

const loadConfigObject = async <T>(configName: ConfigName, dispatch: AppDispatch, dispatcher: { payload?: T; type: string }, useStorage?: boolean) => {
  try {
    const val = await selectConfigString(configName, useStorage);
    if (val) {
      dispatcher.payload = JSON.parse(val) as T;
      dispatch(dispatcher);
    }
  } catch (ex) {
    console.error(`error loading ${configName} data`);
    throw ex;
  }
};
